interface PalmMaskOverlayProps {
  /** Camera step uses semi-transparent overlay; result step adds frame strokes. */
  variant?: "camera" | "result"
}

/** Pill-shaped mask overlay — mask and frames share one viewBox so they scale together. */
export function PalmMaskOverlay({ variant = "camera" }: PalmMaskOverlayProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 414 700"
      preserveAspectRatio="none"
      fill="none"
      aria-hidden
      className="pointer-events-none absolute inset-0 size-full"
    >
      <path
        d="M414 700H0V0H414V700ZM207 72C114.768 72 40 146.768 40 239V421C40 513.232 114.768 588 207 588C299.232 588 374 513.232 374 421V239C374 146.768 299.232 72 207 72Z"
        fill="#0D081C"
        fillOpacity={variant === "camera" ? 0.8 : 1}
      />
      {variant === "result" ? (
        <g transform="translate(16, 48)">
          <path
            d="M0.5 191.5C0.5 86.0136 86.0136 0.5 191.5 0.5C296.986 0.5 382.5 86.0136 382.5 191.5V373.5C382.5 478.986 296.986 564.5 191.5 564.5C86.0136 564.5 0.5 478.986 0.5 373.5V191.5Z"
            stroke="#DFCBF5"
            strokeOpacity={0.1}
          />
          <path
            d="M12.5 191.5C12.5 92.641 92.641 12.5 191.5 12.5C290.359 12.5 370.5 92.641 370.5 191.5V373.5C370.5 472.359 290.359 552.5 191.5 552.5C92.641 552.5 12.5 472.359 12.5 373.5V191.5Z"
            stroke="#DFCBF5"
            strokeOpacity={0.2}
          />
        </g>
      ) : null}
    </svg>
  )
}

/** @deprecated Use PalmMaskOverlay */
export const CameraMaskOverlay = () => <PalmMaskOverlay variant="camera" />
